/* global axios */
import ApiClient from './ApiClient';

class GoogleCalendarAPI extends ApiClient {
  constructor() {
    super('google_calendar_integration', { accountScoped: true });
  }

  getStatus() {
    return axios.get(`${this.url}/status`);
  }

  getAuthUrl() {
    return axios.get(`${this.url}/auth_url`);
  }

  disconnect() {
    return axios.delete(this.url);
  }

  updateColor(color) {
    return axios.patch(`${this.url}/update_color`, { color });
  }
}

export default new GoogleCalendarAPI();
